import { render } from "./AuditLogPanel.vue?vue&type=template&id=34b12e1c&scoped=true"
import script from "./AuditLogPanel.vue?vue&type=script&lang=js"
export * from "./AuditLogPanel.vue?vue&type=script&lang=js"

import "./AuditLogPanel.vue?vue&type=style&index=0&id=34b12e1c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34b12e1c"]])

export default __exports__